import React from "react";
import styles from "./styles.module.css";
import CourseTime from "../icons/courseTime";
import CoursePlace from "../icons/coursePlace";
import CourseHours from "../icons/courseHours";
import CoursePath from "../icons/coursePath";
import CourseSchedule from "../icons/courseSchedule";
import NoSSR from "@components/utils/NoSSR";
import Consultation from "../consultation";
import { format, addDays, getDay, nextMonday } from "date-fns";
import { ru } from "date-fns/locale";

const Details = ({ desc, details, video, title, order }) => {
  const parseDescription = (d) => (
    <p className={styles.desc}>
      <span className={styles.firstLetter}>{d[0]}</span>
      {d.slice(1)}
    </p>
  );

  function getValidDay(date) {
    const number = getDay(date);
    if (number === 0) {
      return 6;
    }

    return number;
  }

  function formatDisplay(date) {
    return format(date, "d MMMM", { locale: ru });
  }

  function getStartCourseDate(currentDate, courseStartDay) {
    let result = currentDate;
    if (getValidDay(currentDate) > courseStartDay + 1) {
      result = nextMonday(result);
      return addDays(result, courseStartDay);
    }

    return addDays(result, courseStartDay - getValidDay(currentDate) + 1);
  }

  return (
    <>
      <NoSSR>
        <div className={styles.root}>
          <div className={styles.mobileDisplayNone}>
            <Consultation title={title} />
          </div>

          {video && (
            <div className={styles.video}>
              <div style={{ padding: "61.25% 0 0 0", position: "relative" }}>
                <iframe
                  src={video}
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                  }}
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          )}
          <div className={styles.detailsText}>
            {parseDescription(desc)}

            <div className={styles.level}>
              <div className={styles.svg}>
                <CourseSchedule />
                <span className={styles.text}>
                  Старт{" "}
                  {formatDisplay(getStartCourseDate(new Date(), order - 1))}
                </span>
              </div>
              <div className={styles.svg}>
                <CourseTime />
                <span className={styles.text}>{details[4]}</span>
              </div>
              <div className={styles.svg}>
                <CoursePath />
                <span className={styles.text}>{details[1]}</span>
              </div>
              <div className={styles.svg}>
                <CourseHours />
                <span className={styles.text}>{details[2]}</span>
              </div>
              <div className={styles.svg}>
                <CoursePlace />
                <span className={styles.text}>{details[3]}</span>
              </div>
            </div>
          </div>
        </div>
      </NoSSR>
    </>
  );
};

export default Details;
